import MultiParentClothesRail from '../MultiParentClothesRail';

export default class ClothesRail extends MultiParentClothesRail {
  //Keep for now, JONAXEL and AURDAL implementations will differ in the future
}
